// @ts-nocheck
import React from 'react';
import { ShadowButton } from 'components/utility/Buttons';
import { toggleCalendar } from 'reducers/slices/calendarstatus';
import { toggleLevels } from 'reducers/slices/hskstatus';
import { ReadSwitch } from 'components/utility/ReadSwitch';
import {
  Stack,
  XStack,
  SizableText,
  useMedia,
  styled,
  useTheme,
} from 'tamagui';
import { Center } from 'components/base/General';
import { HSKModal as HSKs } from 'components/utility/Levels';
import { CalendarButton, LevelsButton } from 'components/utility/General';
import { CalendarModal as Calendar } from 'components/utility/Calendar';
import { useDispatch, useSelector } from 'react-redux';

interface IFilters extends FiltersPropsRedux {
  forceShow: boolean;
  hideCalendar: boolean;
}

const Filters = (props: IFilters) => {
  const theme = useTheme();
  const media = useMedia();
  const dispatch = useDispatch();
  const hskstatus = useSelector((state) => state.hskstatus);
  const calendarstatus = useSelector((state) => state.calendarstatus);
  const filters = useSelector((state) => state.filters);

  const parentToggleLevels = () => {
    dispatch(toggleLevels(!hskstatus));
  };

  const parentToggleCalendar = () => {
    dispatch(toggleCalendar(!calendarstatus));
  };

  let breakPointVal = false;
  if (media.md || media.lg || media.xl) {
    breakPointVal = true;
  }

  return (
    <>
      <Center width="100%">
        <Stack
          gap={10}
          flexDirection="column"
          py={1}
          $sm={{ py: 2 }}
          width="100%"
          $md={{ flexDirection: 'row', space: 0, width: '98%' }}
          $xl={{ width: '75%' }}
          justifyContent="space-around"
          alignItems="center"
          nativeID="filters"
        >
          <XStack
            gap={20}
            flexGrow={1}
            justifyContent="center"
            $sm={{ justifyContent: 'space-around' }}
          >
            {props.hideCalendar ? (
              <Stack />
            ) : (
              <ShadowButton onPress={parentToggleCalendar}>
                <XStack
                  px={5}
                  alignItems="center"
                  justifyContent="space-between"
                  width="100%"
                >
                  <Stack>
                    <SizableText color={theme.mainColor.get()} fontSize={24}>
                      Calendar
                    </SizableText>
                  </Stack>
                  <Stack>
                    <CalendarButton />
                  </Stack>
                </XStack>
              </ShadowButton>
            )}
            <ShadowButton onPress={parentToggleLevels}>
              <XStack
                px={5}
                alignItems="center"
                justifyContent="space-between"
                width="100%"
              >
                <Stack>
                  <SizableText color={theme.mainColor.get()} fontSize={24}>
                    Levels
                  </SizableText>
                </Stack>
                <LevelsButton />
              </XStack>
            </ShadowButton>
            {breakPointVal ? <Stack /> : null}
          </XStack>
          <ReadSwitch />
        </Stack>
        <Stack height={0} />
      </Center>
      {calendarstatus ? (
        <Calendar calendarstatus={calendarstatus} />
      ) : (
        <Stack />
      )}
      {hskstatus ? <HSKs hskstatus={hskstatus} /> : null}
    </>
  );
};

export default Filters;
